import { render } from "./introductionComponent.vue?vue&type=template&id=a04fe83a&scoped=true"
import script from "./introductionComponent.vue?vue&type=script&lang=js"
export * from "./introductionComponent.vue?vue&type=script&lang=js"

import "./introductionComponent.vue?vue&type=style&index=0&id=a04fe83a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04fe83a"]])

export default __exports__